import * as constants from '../constants';
import converter from '../converter';

const initialState = {};

export default function reducer(state = initialState, action) {
    switch (action.type) {
        case constants.getHarmfulObjects.success: {
            return action.payload;
        }

        case constants.getHarmfulObjects.error: {
            return { error: 'backend error' };
        }

        default:
            return state;
    }
}
